// Central media + copy tokens for the Holideviser homepage.
export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/95f0c1b8-40f4-4cbf-9993-c9b0f89e1bea/images/984de72614cce750ec57d9e0e17038e24926485a46abb103b0cbffc77449c0a4.jpeg",
  vietnam:
    "https://static.prod-images.emergentagent.com/jobs/95f0c1b8-40f4-4cbf-9993-c9b0f89e1bea/images/a76feb51f0b521d93e757d58ca962ffb184aa56f014d928a056fc4a7c20e44b0.jpeg",
  danang:
    "https://static.prod-images.emergentagent.com/jobs/95f0c1b8-40f4-4cbf-9993-c9b0f89e1bea/images/e5767a3519ace0f35716bf39f23fc8b288dfa15b9a5d400e374916c38a8ca0cd.jpeg",
};

export const NAV_LINKS = [
  { label: "Discoverography", id: "discoverography" },
  { label: "Destinations", id: "destinations" },
  { label: "How It Works", id: "how-it-works" },
];

export const COMING_SOON = [
  { name: "THAILAND", index: "02" },
  { name: "BALI", index: "03" },
  { name: "SRI LANKA", index: "04" },
];
